import { Component, computed, EventEmitter, Input, Output, Signal, signal, WritableSignal } from '@angular/core';
import { Route } from 'src/app/models/enums/Route.enum';
import { Price } from 'src/app/models/types/Product/Price.type';
import { Product } from 'src/app/models/types/Product/Product.type';
import { StockAndPriceService } from 'src/app/services/api/stock-and-price.service';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrl: './product.component.scss',
  standalone: false,
})
export class ProductComponent {
  @Input('overrideCallback') overrideCallback?: Function;

  @Input('product') product!: Product;
  @Input('newIn') newIn?: boolean;
  @Input('isInSearchPage') isInSearchPage?: boolean;

  private _price: WritableSignal<Price | null | undefined> = signal(undefined);
  public price: Signal<Price | null | undefined> = computed(() => { return this._price() });
  public priceLabel: Signal<string> = computed(() => this.buildPriceLable());

  public loading: WritableSignal<boolean> = signal(false);

  constructor(
    public readonly authService:AuthService,
    private readonly sharedService: SharedService,
    private readonly stockAndPriceService: StockAndPriceService
  ) { }

  public getProductLink(sapCode: string): string {
    return `/${Route.Main}/${Route.Product}/${sapCode}`;
  }

  public loadPrice(event: Event, sapCode: string) {
    event.stopPropagation();
    this.loading.set(true);
    this.stockAndPriceService.getPriceBySapCode(sapCode).subscribe({
      next: (res) => {
        this._price.set(res);
        this.loading.set(false);
      },
      error: (err) => {
        console.log(err);
        this.loading.set(false);
      }
    })
  }

  public goToPDP(sapCode: string) {
    if (this.overrideCallback) {
      this.overrideCallback(sapCode);
    } else {
      this.sharedService.navigateTo_ProductPage(sapCode);
    }
  }

  public buildPriceLable(): string {
    return this.sharedService.getPriceLabel(this.price());
  }

}
